export const CompanyCodeToNameMap: Record<string, string> = {
  '1000': 'Davey Tree Expert',
  '1001': 'S&S Tree',
  '1002': 'WSSI',
  '1003': 'Conserv. Land Stewardship',
  '1004': 'Davey Resource Group',
  '1005': 'Amy Greene Environmental',
  '1006': 'DRG Pacific Services',
  '1007': 'Davey Tree Puerto Rico',
  '1008': 'Mickman Brothers',
  '1009': 'VanCuren Services',
  '2000': 'Davey Tree Surgery',
  '3000': 'Davey Tree Expert-Canada',
  '4000': 'Standing Rock Insurance',
  '5000': 'DTE - WSSI Facility',
  '6000': 'Wolf Tree',
  '7000': 'The Care of Trees',
  AQ01: 'Hartney Greymont',
  MUSI: 'Martinez Utility Services',
};
